class AnalyticsService {

    static initialiseGA(userID) {
        //initialise google analytics
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
        if(userID)
        {
            window.ga('create', 'UA-53047713-1', 'auto', { 'userId': userID });
        }
        else
        {
            window.ga('create', 'UA-53047713-1', 'auto');
        }
    }

    static initialiseFB() {
        //initialise FB analytics
        !function (f, b, e, v, n, t, s) {
            if (f.fbq) return; n = f.fbq = function () {
                n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            }; if (!f._fbq) f._fbq = n;
            n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
            t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
        }(window,
        document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '756859017696922');
    }

    static initialiseBing() {
        (function (w, d, t, r, u) { 
            var f, n, i; 
            w[u] = w[u] || [], f = function () { var o = { ti: "4006212" }; o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad") }, n = d.createElement(t), n.src = r, n.async = 1, n.onload = n.onreadystatechange = function () { var s = this.readyState; s && s !== "loaded" && s !== "complete" || (f(), n.onload = n.onreadystatechange = null) }, i = d.getElementsByTagName(t)[0], i.parentNode.insertBefore(n, i) })(window, document, "script", "//bat.bing.com/bat.js", "uetq");
    }

    /*static initialiseTwitter() {
        //the below doesn't work, we'd need to maybe load similar to in the widget service, but make sure they don't clash. let's leave this out for now.
        require('https://platform.twitter.com/oct.js');
    }*/

    static initialiseHotjar() {   
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:260389,hjsv:5};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'//static.hotjar.com/c/hotjar-','.js?sv=');
    }

    static logPageViewGA(url) {
        if(window.ga) {
            window.ga('send', 'pageview', url);
        }
    }

    static logPageViewFB(url) {
        if (window.fbq) {
            window.fbq('track', 'PageView');
        }
    }

    static logEventGA(category, action, label) {
        if (window.ga) {
            window.ga('send', 'event', category, action, label);
        }
    }

    static logEventFB(eventName, customEvent = true, param = null) {
        if (window.fbq) {
            window.fbq(customEvent ? 'trackCustom' : 'track', eventName, param);
        }
    }

    static logEventBing(category, action, label) {
        window.uetq = window.uetq || [];
        window.uetq.push({ 'ec': category, 'ea': action, 'el': label });
    }

    /*static logRegistrationTwitter() {
        if(window.twttr) {
            window.twttr.conversion.trackPid('l5w79', { tw_sale_amount: 0, tw_order_quantity: 0 });
        }
    }*/
}
export default AnalyticsService;